import { css } from "@emotion/react";

export const addStylesTitle = props => css`
  text-align: center;
  margin-bottom: 24px;
  @media (min-width: ${props.theme.screenSizes.mdMax}) {
    text-align: start;
    margin-bottom: 64px;
  }
`;
